import { getVal, isEmpty, isLoaded } from 'react-redux-firebase';
import dayjs from 'dayjs';
import { createSelector } from 'reselect';

import { STORE_TIMESLOT_AS } from './constants';

/**
 * Get start of month
 */
export const getStartOfMonth = (state, props) =>
  dayjs(props.date).startOf('month');

/**
 * Time slots input selector
 * @param {Object} state component state
 */
const getTimeslots = state => {
  const value = getVal(state.firebase.ordered, STORE_TIMESLOT_AS);
  return isLoaded(value) ? value : false;
};

const getFilter = (state, props) => props.timeslotFilter;

export const getFilteredTimeslots = createSelector(
  [getTimeslots, getFilter],
  (timeslots, filter) => {
    if (!timeslots || !filter) {
      return timeslots;
    }
    return timeslots.filter(filter);
  }
);

/**
 * Get aggregated information (occuapncies and holiday) for each day
 */
export const getDateInfo = createSelector(
  [getStartOfMonth, getFilteredTimeslots],
  (month, timeslots) => {
    // No timeslots
    if (timeslots === null) {
      return {};
    }
    // Loading
    if (!timeslots || isEmpty(timeslots)) {
      return undefined;
    }
    /**
     * Copy of timeslots
     */
    let endOfDay = dayjs(month).add(1, 'day');
    const endOfMonth = dayjs(endOfDay)
      .add(1, 'month')
      .startOf('month');

    const slots = [...timeslots];
    const dateInfo = {};
    for (
      let unixStartOfDay = month.unix();
      endOfDay.isSame(endOfMonth) || endOfDay.isBefore(endOfMonth);
      endOfDay = endOfDay.add(1, 'day')
    ) {
      dateInfo[unixStartOfDay] = { capacity: 0, count: 0 };

      while (slots.length && endOfDay.isAfter(slots[0].value.time * 1000)) {
        if (!slots[0].value.cancelled) {
          dateInfo[unixStartOfDay].capacity += +slots[0].value.playerCapacity;
          dateInfo[unixStartOfDay].count += +slots[0].value.playerCount;
          dateInfo[unixStartOfDay].isHoliday = slots[0].value.isHoliday;
        }
        slots.splice(0, 1);
      }
      unixStartOfDay = endOfDay.unix();
    }
    return dateInfo;
  }
);
